const verifyAccountConfig = ($stateProvider) => {

  'ngInject';

  $stateProvider
    .state('verifyAccount', {
      url: '/verify-account?e={email}&t={token}',
      template: '<verify-account></verify-account>',
      access: {
        loginRequired: false,
      },
      resolve: {
        // used to set the page title
        $title: () => 'Validación de la cuenta',
      },
    });
};

export default verifyAccountConfig;



// WEBPACK FOOTER //
// ./src/modules/verify-account/verify-account.config.js